import { render } from "./CategoriesList.vue?vue&type=template&id=404717f4&scoped=true"
import script from "./CategoriesList.vue?vue&type=script&lang=js"
export * from "./CategoriesList.vue?vue&type=script&lang=js"

import "./CategoriesList.vue?vue&type=style&index=0&id=404717f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404717f4"]])

export default __exports__